import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { UploadErrors } from "../../type";
import { StyledUploadErrorMessages } from "./styled";

type UploadErrorMessagesProps = {
    errors?: UploadErrors;
};

const UploadErrorMessages: FC<UploadErrorMessagesProps> = ({ errors }) => {
    const { t } = useTranslation();

    return (
        <StyledUploadErrorMessages>
            {!!errors.filesDuplicated.length && <>{t("FileUploader.Errors.FilesDuplicated")}</>}
            {!!errors.filesInvalidType.length && <>{t("FileUploader.Errors.InvalidFormat")}</>}
            {!!errors.filesUploadFailed.length && <>{t("FileUploader.Errors.UploadFail")}</>}
            {!!errors.filesInvalidSize.length && <>{t("FileUploader.Errors.SizeBig")}</>}
            {!!errors.filesTotalSizeExceeded.length && <>{t("FileUploader.Errors.TotalSizeBig")}</>}
        </StyledUploadErrorMessages>
    );
};

export default UploadErrorMessages;
